import * as React from 'react'
import { NextPage } from 'next'
import PropTypes, { InferProps } from 'prop-types'
import Meta from '../Meta'
import Header from '../Header'
import Footer from '../Footer'

const layoutPropTypes = {
  headerHTML: PropTypes.string.isRequired,
  footerHTML: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  partner: PropTypes.shape({
    plfCode: PropTypes.string,
    globalPartnerCode: PropTypes.string,
    config: PropTypes.object
  })
}

type layoutProps = InferProps<typeof layoutPropTypes>

const Layout: NextPage<layoutProps> = ({
  headerHTML,
  footerHTML,
  children,
  partner
}) => (
  <>
    <Meta partner={partner} />
    <Header headerHTML={headerHTML} partner={partner} />
    {children}
    <Footer footerHTML={footerHTML} partner={partner} />
  </>
)

Layout.propTypes = layoutPropTypes

export default Layout
